import React from 'react';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import {
    FaTachometerAlt,
    FaBoxes,
    FaShoppingCart,
    FaShoppingBasket,
    FaDollarSign,
    FaCalculator,
    FaChartArea,
    FaCog,
    FaArrowRight,
    FaUserCircle,
    FaSignOutAlt
} from 'react-icons/fa';
import { authActions } from '../../sagas/authSlice';
import './ModuleSelector.css';

const ModuleSelector = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { fullName, businessName } = useSelector(state => state.auth);

    const modules = [
        {
            id: 'dashboard',
            title: t('modules.dashboard.title'),
            description: t('modules.dashboard.description'),
            icon: FaTachometerAlt,
            color: '#007bff',
            route: '/dashboard',
            features: [
                t('modules.dashboard.feature1'),
                t('modules.dashboard.feature2'),
                t('modules.dashboard.feature3')
            ]
        },
        {
            id: 'inventory',
            title: t('modules.inventory.title'),
            description: t('modules.inventory.description'),
            icon: FaBoxes,
            color: '#28a745',
            route: '/inventory-module',
            features: [
                t('modules.inventory.feature1'),
                t('modules.inventory.feature2'),
                t('modules.inventory.feature3'),
                t('modules.inventory.feature4')
            ]
        },
        {
            id: 'sales',
            title: t('modules.sales.title'),
            description: t('modules.sales.description'),
            icon: FaShoppingCart,
            color: '#17a2b8',
            route: '/sales-module',
            features: [
                t('modules.sales.feature1'),
                t('modules.sales.feature2'),
                t('modules.sales.feature3'),
                t('modules.sales.feature4')
            ]
        },
        {
            id: 'purchases',
            title: t('modules.purchases.title'),
            description: t('modules.purchases.description'),
            icon: FaShoppingBasket,
            color: '#fd7e14',
            route: '/purchases-module',
            features: [
                t('modules.purchases.feature1'),
                t('modules.purchases.feature2'),
                t('modules.purchases.feature3')
            ]
        },
        // {
        //     id: 'finance',
        //     title: t('modules.finance.title'),
        //     description: t('modules.finance.description'),
        //     icon: FaDollarSign,
        //     color: '#ffc107',
        //     route: '/finance-module',
        //     features: [
        //         t('modules.finance.feature1'),
        //         t('modules.finance.feature2')
        //     ]
        // },
        // {
        //     id: 'crm',
        //     title: t('modules.crm.title'),
        //     description: t('modules.crm.description'),
        //     icon: FaUserCircle,
        //     color: '#20c997',
        //     route: '/crm-module',
        //     features: [
        //         t('modules.crm.feature1'),
        //         t('modules.crm.feature2'),
        //         t('modules.crm.feature3')
        //     ],
        //     comingSoon: true
        // },
        // {
        //     id: 'hr',
        //     title: t('modules.hr.title'),
        //     description: t('modules.hr.description'),
        //     icon: FaUserCircle,
        //     color: '#ff6f61',
        //     route: '/hr-module',
        //     features: [
        //         t('modules.hr.feature1'),
        //         t('modules.hr.feature2'),
        //         t('modules.hr.feature3')
        //     ],
        //     comingSoon: true
        // },
        {
            id: 'accounting',
            title: t('modules.accounting.title'),
            description: t('modules.accounting.description'),
            icon: FaCalculator,
            color: '#6610f2',
            route: '/accounting-module',
            features: [
                t('modules.accounting.feature1'),
                t('modules.accounting.feature2'),
                t('modules.accounting.feature3')
            ]
        },
        // {
        //     id: 'reports',
        //     title: t('modules.reports.title'),
        //     description: t('modules.reports.description'),
        //     icon: FaChartArea,
        //     color: '#e83e8c',
        //     route: '/reports-module',
        //     features: [
        //         t('modules.reports.feature1'),
        //         t('modules.reports.feature2')
        //     ]
        // },
        {
            id: 'settings',
            title: t('modules.settings.title'),
            description: t('modules.settings.description'),
            icon: FaCog,
            color: '#6c757d',
            route: '/settings-module',
            features: [
                t('modules.settings.feature1')
            ]
        },

    ];

    const handleModuleSelect = (moduleRoute) => {
        // Store selected module in localStorage for persistence
        localStorage.setItem('selectedModule', moduleRoute);
        navigate(moduleRoute);
    };

    const handleLogout = () => {
        console.log('Logout button clicked');
        console.log('authActions:', authActions);
        console.log('authActions.logout:', authActions.logout);
        console.log('dispatch:', dispatch);

        Swal.fire({
            title: 'Confirmer la déconnexion',
            text: 'Êtes-vous sûr de vouloir vous déconnecter ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Se déconnecter',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            console.log('SweetAlert result:', result);
            if (result.isConfirmed) {
                console.log('Dispatching logout...');
                try {
                    dispatch(authActions.logout());

                    // Clear localStorage
                    localStorage.removeItem('selectedModule');
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');

                    Swal.fire({
                        icon: 'success',
                        title: 'Déconnexion réussie',
                        showConfirmButton: false,
                        timer: 1500
                    }).then(() => {

                        console.log('Navigating to login...');
                        navigate('/login');
                    });
                } catch (error) {
                    console.error('Error during logout:', error);
                }
            }
        }).catch((error) => {
            console.error('SweetAlert error:', error);
        });
    };

    return (
        <div className="module-selector-wrapper">
            {/* Compact Hero Section */}
            <div className="hero-section">
                <Container>
                    <div className="text-center text-white py-2">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="flex-grow-1 mb-2 mb-lg-0">
                                <h3 className="fw-bold mb-1">
                                    {t('modules.welcome', { businessName })}
                                </h3>
                                <p className="mb-0 opacity-75 small">
                                    {t('modules.selectModuleDescription')}
                                </p>
                            </div>
                            <div className="user-info ms-lg-4">
                                <div className="d-flex align-items-center gap-3 flex-wrap justify-content-center justify-content-lg-end">
                                    <div className="d-flex align-items-center bg-white bg-opacity-10 rounded-pill px-3 py-2">
                                        <FaUserCircle className="me-2" size={20} />
                                        <span className="small">{fullName}</span>
                                    </div>
                                    <Button
                                        color="outline-light"
                                        size="sm"
                                        onClick={handleLogout}
                                        className="d-flex align-items-center rounded-pill px-3"
                                    >
                                        <FaSignOutAlt className="me-2" size={14} />
                                        <span className="small">Déconnexion</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>

            {/* Centered Modules Grid */}
            <Container className="py-4">
                <div className="d-flex justify-content-center">
                    <div style={{ maxWidth: '1200px', width: '100%' }}>
                        <div className="modules-grid">
                            {modules.map((module, index) => (
                                <div className="module-col" key={module.id}>
                                    <Card
                                        className={`module-card h-100 shadow-sm border-0${module.comingSoon ? ' module-coming-soon' : ''}`}
                                        onClick={() => !module.comingSoon && handleModuleSelect(module.route)}
                                        style={{ cursor: module.comingSoon ? 'not-allowed' : 'pointer', opacity: module.comingSoon ? 0.6 : 1 }}
                                    >
                                        <CardBody className="p-4 d-flex flex-column h-100">
                                            {/* Icon and Title Section */}
                                            <div className="text-center mb-3">
                                                <div
                                                    className="module-icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                                    style={{
                                                        backgroundColor: `${module.color}15`,
                                                        width: '60px',
                                                        height: '60px',
                                                        border: `2px solid ${module.color}30`
                                                    }}
                                                >
                                                    <module.icon
                                                        size={28}
                                                        style={{ color: module.color }}
                                                    />
                                                </div>
                                                <h5 className="module-title fw-bold mb-2 text-center">
                                                    {module.title}
                                                    {module.comingSoon && (
                                                        <span className="badge bg-warning ms-2">{t('modules.comingsoon')}</span>
                                                    )}
                                                </h5>
                                            </div>

                                            {/* Features Section */}
                                            <div className="module-features mb-3 flex-grow-1">
                                                <div className="d-flex flex-wrap justify-content-center gap-1">
                                                    {module.features.slice(0, 4).map((feature, index) => (
                                                        <span key={index} className="badge bg-light text-dark small px-2 py-1">
                                                            {feature}
                                                        </span>
                                                    ))}
                                                    {module.features.length > 4 && (
                                                        <span className="badge bg-secondary small px-2 py-1">
                                                            +{module.features.length - 4}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Action Button */}
                                            <div className="module-action mt-auto">
                                                <Button
                                                    className="w-100 fw-bold"
                                                    style={{
                                                        backgroundColor: module.color,
                                                        borderColor: module.color,
                                                        color: 'white'
                                                    }}
                                                    size="sm"
                                                    disabled={module.comingSoon}
                                                >
                                                    <FaArrowRight className="me-2" size={12} />
                                                    {module.comingSoon ? t('modules.comingSoon') : t('modules.accessModule')}
                                                </Button>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            ))}
                        </div>

                        {/* Inline Quick Stats */}
                        <div className="quick-stats-inline mt-5 pt-4 border-top">
                            <Row className="text-center">
                                <Col xs={3}>
                                    <div className="stat-item-inline">
                                        <h5 className="fw-bold text-primary mb-1">{modules.length}</h5>
                                        <small className="text-muted">{t('modules.totalModules')}</small>
                                    </div>
                                </Col>
                                <Col xs={3}>
                                    <div className="stat-item-inline">
                                        <h5 className="fw-bold text-success mb-1">24/7</h5>
                                        <small className="text-muted">{t('modules.availability')}</small>
                                    </div>
                                </Col>
                                <Col xs={3}>
                                    <div className="stat-item-inline">
                                        <h5 className="fw-bold text-info mb-1">100%</h5>
                                        <small className="text-muted">{t('modules.uptime')}</small>
                                    </div>
                                </Col>
                                <Col xs={3}>
                                    <div className="stat-item-inline">
                                        <h5 className="fw-bold text-warning mb-1">∞</h5>
                                        <small className="text-muted">{t('modules.scalability')}</small>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default ModuleSelector;
